import WorkUploaded from '@/apps/WorkUploaded'
import React from 'react'

const WorkUploadedBody = (): React.ReactElement => {
  return <WorkUploaded />
}

export default WorkUploadedBody
